import { consumeContext } from "../consume_context"
import { Game } from "../game"
import { NavigationContainer } from "./container"

export const NavigationConsumer = consumeContext({
  Context: Game.Context,
  provideTo: "gameContext",
})(NavigationContainer)
